import { useDispatch, useSelector } from "react-redux"
import * as authAction from '../../../redux/auth/action'

interface IDispatchLogin {
    auth: string;
}

export const useLogin = () => {
    const dispatch = useDispatch();
    const isLoading = useSelector((state: IAuthState) => state.auth.loading);
    const userState = useSelector((state: IAuthState) => state.auth.user);

    const dispatchLogin = (body: IDispatchLogin) => {
        setTimeout(() => dispatch(authAction.userLoginGoogle(body)), 200)
    }

    return {
        dispatchLogin,
        isLoading,
        userState
    }
}